<template>
  <span>
    <slot>
      <i18n-t keypath="From {price} per stay">
        <template #price>
          <em><pu-price :price="price" /></em>
        </template>
      </i18n-t>
    </slot>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { SimpleMoney } from '~/utility/money'

@Component
class MiniCardPrice extends Vue {
  @Prop()
  price: SimpleMoney
}

export default toNative(MiniCardPrice)
</script>
